<template>
  <section class="app-main">
    <div class="top-bar">
      <el-date-picker
        v-model="coupon.fixDate"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px; margin-right: 15px"
      ></el-date-picker>
      <el-input
        placeholder="搜索模块"
        v-model="title"
        style="width: 300px"
        @change="getData"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <!-- 商品列表 -->
    <div class="content">
      <el-table :data="tableData" height="630" style="width: 100%">
        <el-table-column
          prop="title"
          label="模块名称"
          width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="email"
          label="用户点击量"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="email"
          label="游客点击量"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column label="详情" width="180" align="center">
          <template slot-scope="scope">
            <p>
              <el-button size="small" @click="startCheck(scope.row)"
                >查看</el-button
              >
            </p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :current-page.sync="page"
        style="padding: 10px"
        :total="total"
        @current-change="loadPage"
      ></el-pagination>
    </div>
  </section>
</template>



<script>
import { merchantApply, setMergoodsStatus } from "@/api/summary.js";

export default {
  data() {
    return {
      title: "",
      page: 1,
      total: 0,
      tableData: [],
      coupon: {
        fixDate: [],
        periodType: "",
      },
    };
  },
  methods: {
    // 日期查询搜索
    handleDate() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = {
        page: this.page,
      };
      if (this.title != "") {
        params.title = this.title;
      }
    // if (this.coupon.fixDate && this.coupon.fixDate.length != 0) {
    //     params.start_date_search = this.coupon.fixDate[0];
    //     params.end_date_search = this.coupon.fixDate[1];
    //   }
      this.table_load = true;
      merchantApply("3", params)
        .then((res) => {
          if (res.status === 1) {
            this.table_load = false;
            this.tableData = res.list.data;
            this.total = res.list.total;
          } else {
            this.table_load = false;
            this.$message({ message: res.msg, type: "error", offset: "200" });
          }
        })
        .catch((err) => {
          this.table_load = false;
          console.log(err);
        });
    },
    loadPage(page) {
      this.page = page;
      this.getData();
    },
    scaleImg(url) {
      this.dialogVisible = true;
      this.dialogImageUrl = url;
    },
    startCheck(row) {
      this.row = row;
      this.edit_modal = true;
    },
    agree() {
      if (this.row.rate == "") {
        this.$message.error("请完善商家税率...");
        return false;
      }
      let params = {
        is_packing: this.row.is_packing,
        rate: this.row.rate,
        is_stock: this.row.is_stock,
      };
      setMergoodsStatus(this.row.id, params)
        .then((res) => {
          if (res.status == 1) {
            this.$message({ message: res.msg, type: "success", offset: "200" });
            this.getData();
            this.innerVisible = false;
            this.edit_modal = false;
          } else {
            this.$message({ message: res.msg, type: "error", offset: "200" });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    // this.getData()
  },
};
</script>

<style lang="less" scoped>
.section {
  .top-bar {
    padding: 0 30px 20px;
    width: 100%;
    > p {
      height: 50px;
      line-height: 50px;
      text-align: center;
    }
  }
  .content {
    margin: 10px 30px;
    border: 1px solid #e0e0e0;
  }
  .shop-title {
    text-align: left;
    height: 40px;
    line-height: 40px;
  }
  .shop-info {
    border: 1px solid #e0e0e0;
    text-align: left;
    padding-left: 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
  }
  .imgs-box {
    height: 120px;
    text-align: left;
    > img {
      height: 120px;
      margin-right: 50px;
    }
  }
}
</style>


